function Clients(){
    return (

        <section className="py-5">
            <div className="container">
            {/*row*/}
            <div className="row">
                <div className="col-md-12">
                    {/*text*/}
                    <div className="d-flex justify-content-center text-center mb-5">
                        <h4 className="mb-0">
                        Our Valued Partners
                        </h4>
                    </div>
                </div>
            </div>
            {/*row*/}
            <div className="row row-cols-xl-7 gy-5">
                {/*logo*/}
                <div className="border-end-0 border-end-md text-center col">
                    <img src="https://www.imec-int.com/assets/img/imec-logo.svg" alt="IMEC logo"  height={50} />
                </div>
                {/*logo*/}
                <div className="border-end-0 border-end-md text-center col">
                    <img src="https://www.imeciclink.com/assets/img/imec-iclink-logo.svg" alt="IC-link Logo"  height={50}  />
                </div>
                {/*logo*/}
                {/*<div className="text-center col">*/}
                <div className="border-end-0 border-end-md text-center col">
                    <img src="https://europractice-ic.com/wp-content/uploads/2021/05/logo-europractice.png" height={50} alt="Europractice Logo" /> 
                </div>
            </div>
            </div>
        </section>
    )

}

export default Clients